<div
	class="w-full flex-1 cursor-pointer"
	(click)="generateLink ? (isShop ? onDetailShop() : onDetailKarya()) : null">
	<div class="container-add" *ngIf="showIcon">
		<div class="container-like hidden">
			<img class="icon-heart-book" src="../../../../assets/icons/icon-heart.svg" alt="like" />
			<span>{{ post.likes }}</span>
		</div>
		<div class="container-view" *ngIf="showViewer">
			<img class="w-5 mobile:w-4" src="../../../../assets/gif/read40black.gif" alt="view" />
			<span>{{ post.views }}</span>
		</div>
		<div class="container-wacacoin" *ngIf="post.isMonetized && showMonetized">
			<img
				class="icon-wacacoin"
				src="../../../../assets/gif/wacacoin.gif"
				alt="Icon Wacacoin" />
		</div>
	</div>

	<div class="relative w-full aspect-7/10">
		<app-skeleton class="absolute" [type]="skeletonOptions.POST_COVER"></app-skeleton>
		<div
			*ngIf="post.coverCustom"
			class="w-full aspect-[7/10] rounded-lg flex justify-center absolute bg-center bg-cover"
			[ngStyle]="{
				'background-image': 'url(' + post.coverCustom.backgroundUrl + ')',
				'font-size': post.coverCustom.fontSize + 'px',
				color: post.coverCustom.color
			}">
			<div class="w-full flex items-center justify-center">
				<p class="w-full text-center leading-snug px-2">
					{{ post.coverCustom.title || '' }}
				</p>
			</div>
		</div>

		<div class="w-full aspect-[7/10] absolute" *ngIf="post.coverImage">
			<img
				class="w-full aspect-[7/10] rounded-lg object-cover"
				src="{{ post.coverImage }}"
				alt="cover" />
		</div>

		<img
			class="img-book z-10"
			src="assets/images/no-cover.jpg"
			*ngIf="(!post.coverImage || post.coverImage === '') && !post.coverCustom"
			alt="" />

		<div
			*ngIf="ranking > 0"
			class="absolute flex items-center justify-center bottom-2 left-2 w-9 h-9 rounded-full text-white waca-bg-primary text-xl border-2 border-white z-20">
			{{ ranking }}
		</div>
	</div>

	<div class="content-book-card">
		<div class="w-full truncate text-xs font-light" *ngIf="showPrice">
			<div class="text-[#E10000] text-lg font-semibold">Rp.35.000</div>
		</div>
		<div class="w-full truncate text-xs font-light" *ngIf="showAuthor">
			@{{ post?.author?.username }}
		</div>
		<div *ngIf="showTitle" class="title-book text-base mobile:text-sm mobile:leading-tight">
			{{ post?.title }}
		</div>
	</div>
</div>
